<template>
  <header class="header" :class="{ 'header--scrolled': isScrolled }">
    <div class="header-container">
      <button class="header-menu" data-toggle=".menu">
        <Icon name="ri:menu-2-line" />
        <span>{{ $t("header.menu") }}</span>
      </button>
      <NuxtLinkLocale to="/" class="header-logo" aria-label="Logo">
        <ElementsLogo />
      </NuxtLinkLocale>
      <div class="header-actions">
        <LayoutLanguage />
        <a href="https://zimmer-hotel-bosphorus.hotelrunner.com/bv3/search" class="header-actions__button">{{ $t("header.reservation") }}</a>
      </div>
    </div>
  </header>
</template>

<script setup lang="ts">
  const isScrolled = ref(false)

  const checkScroll = () => {
    isScrolled.value = window.scrollY > 50
  }

  onMounted(() => {
    checkScroll()
    window.addEventListener("scroll", checkScroll)
  })

  onUnmounted(() => {
    window.removeEventListener("scroll", checkScroll)
  })
</script>

<style lang="scss" scoped>
  .header {
    @apply flex h-25 fixed w-full top-0 left-0 z-200 transition-all duration-200 text-white/85;
    border-bottom: 1px solid transparent;

    &-container {
      @apply grid items-center justify-between w-full px-11;
      grid-template-columns: 1fr min-content 1fr;
    }
    &-menu {
      @apply font-display inline-flex w-fit items-center justify-center gap-2.5 p-0 bg-transparent border-none text-center;
      @apply text-inherit text-3 font-bold leading-4 uppercase p-4 -m-4 mr-auto;
      letter-spacing: 3px;

      :deep(svg) {
        @apply text-6;
      }
    }
    &-logo {
      @apply h-11 mx-auto;

      :deep(svg) {
        @apply h-full w-auto;
      }
    }
    &-actions {
      @apply flex items-center gap-8 ml-auto;

      &__button {
        @apply flex items-center justify-center text-center h-12 px-5 py-3 gap-2.5 border border-solid border-white/50;
        @apply bg-transparent text-inherit text-3 font-bold leading-normal uppercase transition-all duration-200;
        letter-spacing: 2px;

        &:hover {
          @apply bg-white;
          color: #282828;
        }
      }
    }

    &--scrolled {
      @apply opacity-100;
      color: #282828;
      border-color: #e0e0e0;
      background-color: #f2f0e9;
    }
    &--scrolled & {
      &-actions {
        &__button {
          color: #ffffff;
          border-color: #282828;
          background-color: #282828;
        }
      }
    }

    @include media("lg") {
      @apply h-22;

      &-container {
        @apply px-5;
      }
      &-actions {
        &__button {
          display: none;
        }
      }
    }
    @include media("md") {
      @apply h-14;

      &-container {
        @apply px-4;
      }
      &-menu {
        @apply gap-2 text-3;
        letter-spacing: 2px;

        :deep(svg) {
          @apply text-5;
        }
      }
      &-logo {
        @apply h-8;

        :deep(svg) {
          margin-bottom: -12px;
        }
      }
    }
  }
</style>
